import axios from 'axios';
import Cookies from 'js-cookie';
import Marquee from 'react-fast-marquee';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// api
import ApiKey from '../api/ApiKey';
import BaseApi from '../api/BaseApi';
// components
import Footer from '../element/Footer';
import NavBar from '../element/NavBar';
import JobCard from '../element/JobCard';
import CategoryCard from '../element/CategoryCard';
import LazyBackground from '../element/LazyBackground';
import BrowseJobToggler from '../element/BrowseJobToggler';
// helpers
import { logOutIfTokenExpired, resultInfo } from '../helpers';
// mui
import SearchIcon from '@mui/icons-material/Search';
// TODO: remove after backend connect
import { regions } from '../searchJob/settings';
import { TopEmployers } from '../../global/home/top-employers/top-employers';

export const UserPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('global');
  const tokenKey = Cookies.get('tokenClient');
  const primaryColor = Cookies.get('primaryColor');

  const [keyword, setKeyword] = useState('');
  const [loading, setLoading] = useState(true);
  const [showSeoText, setShowSeoText] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [totalPageData, setTotalPageData] = useState([]);

  const {
    keywords = [],
    job_title = [],
    // skillList = [],
    categories = [],
    // sliderList = [],
    // site_setting = {},
    top_employer = [],
    bannerDetails = [],
    latestJobList = [],
    announcementList = [],
    categories_listing = [],
  } = totalPageData;

  const encodeKeyword = keyword => encodeURIComponent(keyword);

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.get(BaseApi + '/home', {
        headers: {
          key: ApiKey,
          token: tokenKey,
          contentType: 'application/json',
        },
      });

      const totalData = response.data.response;

      setLoading(false);
      setTotalPageData(totalData);
    } catch (error) {
      setLoading(false);

      console.error('Cannot get home page data!');
    }
  };

  const toggleSeoText = () => {
    setShowSeoText(!showSeoText);
  };

  const handleDeclarationSubmit = async (slug, coverLetter, selectedResumeId) => {
    setLoading(true);

    try {
      const response = await axios.post(
        BaseApi + `/job/jobApplyDetail/${slug}`,
        {
          title: '',
          message: coverLetter,
          cv_id: selectedResumeId,
        },
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            contentType: 'application/json',
          },
        },
      );

      setLoading(false);

      if (response.data.status === 200) {
        getData();

        resultInfo('success', t('jobDescription.jobAppliedSuccessTitle'), t('jobDescription.close'));
      } else {
        getData();

        resultInfo('error', response.data.message, t('jobDescription.close'));
      }
    } catch (error) {
      setLoading(false);

      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      } else {
        resultInfo('error', t('jobDescription.jobAppliedFailedTitle'), t('jobDescription.close'));
      }

      console.error('Error on clicking the submit button at apply job modal!');
    }
  };

  useEffect(() => {
    const metaTitle = document.querySelector('title');
    const metaDescription = document.querySelector('meta[name="description"]');

    if (metaTitle) {
      metaTitle.textContent = t('userpage.metaTitleValue');
    }

    if (metaDescription) {
      metaDescription.content = t('userpage.metaDescriptionValue');
    }

    getData();
  }, [t]); // eslint-disable-line

  return (
    <>
      <NavBar />
      {
        loading
          ? (
            <div className='loader-container' />
          ) : (
            <div>
              <LazyBackground
                className='sliderbody'
                image375='/Images/mainBanner/main-banner-375.webp'
                image768='/Images/mainBanner/main-banner-768.webp'
                image992='/Images/mainBanner/main-banner-992.webp'
                image1200='/Images/mainBanner/main-banner-1200.webp'
                image1400='/Images/mainBanner/main-banner-1400.webp'
                image1800='/Images/mainBanner/main-banner-1800.webp'
              >
                <div className='lowerSlider'>
                  <div className='container'>
                    <div className='row'>
                      <div className='col'>
                        <div className='slidertext'>
                          <h1><span>GRC.UA</span> — сайт пошуку роботи для професіоналів</h1>
                          {/* <p>{site_setting.slogan_text}</p> */}
                        </div>
                        <div className='searcharea'>
                          <div className='inputGrp'>
                            <SearchIcon
                              sx={{
                                color: '#3C3C3C',
                                width: { xs: 24, sm: 32 },
                                height: { xs: 24, sm: 32 },
                              }}
                            />
                            <input
                              type='search'
                              name='keyword'
                              value={keyword}
                              aria-label='Search'
                              className='form-control'
                              aria-describedby='search-addon'
                              onChange={e => setKeyword(e.target.value)}
                              placeholder={t('userpage.jobTitleKeyword')}
                            />
                          </div>
                          <Link
                            type='button'
                            className='btn btn-primary button1'
                            to={keyword ? `/searchjob/k-${encodeKeyword(keyword)}` : '/searchjob'}
                          >
                            {t('userpage.searchButton')}
                          </Link>
                          {/* <button
                            type='button'
                            className='btn btn-primary uploadCvButton'
                            onClick={() => navigate('/auth/candidate-login')}
                          >
                            {t('userpage.uploadCVButton')}
                          </button> */}
                        </div>
                        {
                          selectedFile && (
                            <div className='mt-3 d-flex'>
                              <p className='pt-2'>
                                Selected File: {selectedFile.name}
                              </p>
                              <button
                                className='btn btn-outline-dark ms-2'
                                onClick={() => setSelectedFile()}
                              >
                                {t('userpage.deleteButton')}
                              </button>
                            </div>
                          )
                        }
                        <div className='slidertext2'>
                          <div className='jobs-clients-posted'>
                            <h3>{totalPageData?.jobscount?.toLocaleString('uk-UA')}</h3>
                            <h6>{t('userpage.jobsPosted')}</h6>
                          </div>
                          <div className='jobs-clients-posted'>
                            <h3>{totalPageData?.freelancers?.toLocaleString('uk-UA')}</h3>
                            <h6>{t('userpage.employers')}</h6>
                          </div>
                          <div className='jobs-clients-posted'>
                            <h3>{totalPageData?.resumes?.toLocaleString('uk-UA')}</h3>
                            <h6>{t('userpage.resumes')}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </LazyBackground>

              {/* TOP EMPLOYERT============================== START */}

               <TopEmployers topEmployers={top_employer}/>
              {/* {
                top_employer.length > 0 && (
                  <section className='TopEmployersSection'>
                    <div className='container text-center'>
                      <h3 className='subsecondblockHeading'>
                        {t('userpage.top')}
                        <span className='textGradient'>
                          {' '}
                          <span className='SubHaddingTxt'>
                            {t('userpage.employer')}
                          </span>{' '}
                        </span>
                      </h3>
                      <div className='TopEmployersBx'>
                        <div className='row m-0'>
                          {
                            top_employer.map(i => (
                              <div key={i.id} className='col-xs-12 col-md-3 col-lg-3 p-0 TopEmployersBxCardBx'>
                                <div className='EmployersLogoBx BorderRight BorderBottom'>
                                  <Link className='EmployersLogoLink' to={`/company/${i.employer_id}`}>
                                    <img
                                      alt={i.slug}
                                      loading='lazy'
                                      src={i.company_logo}
                                      className='employersLogo'
                                    />
                                  </Link>
                                </div>
                              </div>
                            ))
                          }
                        </div>
                      </div>
                    </div>
                  </section>
                )
              } */}
              {/* TOP EMPLOYERT============================== END */}
              <div className='thirdBlock'>
                <div className='container'>
                  <div className='thirdBlockData'>
                    <h3 className='BrowseJobsHadding'>
                      {t('userpage.browseJobs')}
                    </h3>
                    <BrowseJobToggler
                      byRegion={regions}
                      byTitle={job_title}
                      byCategory={categories}
                      byPopularSearch={keywords}
                    />
                  </div>
                </div>
              </div>
              {
                latestJobList.length > 0 && (
                  <section className='FeaturedJobsSection'>
                    <div className='container fourthBlock text-center'>
                      <h3 className='subsecondblockHeading'>
                        {t('userpage.featured')}
                        <span className='textGradient'>
                          {' '}
                          <span className='SubHaddingTxt'>
                            {t('userpage.jobs')}
                          </span>
                        </span>
                      </h3>
                      <div className='FBitem'>
                        <div className='row'>
                          {
                            latestJobList.slice(0, 6).map(i => (
                              <div key={i.id} className='col-md-6 col-lg-4'>
                                <JobCard
                                  logo={i.logo}
                                  slug={i.slug}
                                  title={i.title}
                                  jobId={i.job_id}
                                  getData={getData}
                                  created={i.created}
                                  min_exp={i.min_exp}
                                  cat_slug={i.cat_slug}
                                  job_city={i.job_city}
                                  desc={i.brief_abtcomp}
                                  work_type={i.work_type}
                                  is_applied={i.is_applied}
                                  salary_min={i.salary_min}
                                  salary_max={i.salary_max}
                                  onlyResume={i.only_resume}
                                  company_name={i.company_name}
                                  onlyQuestionnaire={i.questionary}
                                  salary_currency={i.salary_currency}
                                  handleDeclarationSubmit={handleDeclarationSubmit}
                                />
                              </div>
                            ))
                          }
                        </div>
                      </div>
                      <Link to='/searchjob'>
                        <button className='button-view-job btn btn-primary button1'>
                          {t('userpage.viewAllJobsButton')}
                        </button>
                      </Link>
                    </div>
                  </section>
                )
              }
              <div className='sixthBlock'>
                <section className='DownloadAppSection'>
                  <Link to='/searchjob/k-lifecell'>
                    <img
                      alt='image'
                      id='flexImage'
                      loading='lazy'
                      className='flexImage'
                      src='/Images/mainBanner/lifecellMainBanner.png'
                    />
                  </Link>
                </section>

              <section className='CategorySection'>
                <div className='container'>
                  <div className='row'>
                    <div className='col-xs-12 col-md-4 col-lg-4'>
                      <Link to='/searchjob'>
                        <div className='CategoryBx'>
                          <img src='/Images/home/job-search-main.png' alt='' loading='lazy' width={100} />
                          <h5 className=''>{t('userpage.searchDesiredJob')}</h5>
                          <p>{t('userpage.belowTxt2')}</p>
                        </div>
                      </Link>
                    </div>
                    <div className='col-xs-12 col-md-4 col-lg-4'>
                      <Link to='/user/register/jobseeker'>
                        <div className='CategoryBx'>
                          <img src='/Images/home/create-account-main.png' alt='' loading='lazy' width={100} />
                          <h5 className=''>{t('userpage.createAnAcount')}</h5>
                          <p>{t('userpage.belowTxt1')}</p>
                        </div>
                      </Link>
                    </div>
                    <div className='col-xs-12 col-md-4 col-lg-4'>
                      <Link to='/user/register/jobseeker'>
                        <div className='CategoryBx'>
                          <img src='/Images/home/publish-job-main.png' alt='' loading='lazy' width={100} />
                          <h5 className=''>{t('userpage.currentJobs')}</h5>
                          <p>{t('userpage.belowTxt3')}</p>
                        </div>
                      </Link>
                    </div>
                  </div>
                  {
                    categories_listing.length > 0 && (
                      <div className='subsecondblock'>
                        <div className='LeftDotImg'>
                          <img src='/Images/dotimg.png' alt='' loading='lazy' />
                        </div>
                        <div className='RightDotImg'>
                          <img src='/Images/dotimg.png' alt='' loading='lazy' />
                        </div>
                        <h3 className='subsecondblockHeading'>
                          {t('userpage.explore')}
                          <span className='textGradient'>
                            {' '}
                            <span className='SubHaddingTxt'>
                              {t('userpage.categories')}{' '}
                            </span>
                          </span>
                        </h3>
                        <div className='ExploreCategory'>
                          <div className='row'>
                            {
                              categories_listing.map(i => (
                                <div key={i.id} className='col-md-6 col-lg-3 HomeCategorysCardBx'>
                                  <CategoryCard
                                    id={i.id}
                                    slug={i.slug}
                                    title={i.name}
                                    image2={i.image}
                                    footer={i.sub_cat}
                                    image1='/Images/Back-1.png'
                                  />
                                </div>
                              ))
                            }
                          </div>
                          <Link
                            type='button'
                            to='/allcategory'
                            className='btn btn-primary button1'
                          >
                            {t('userpage.exploreAllCategories')}
                          </Link>
                        </div>
                      </div>
                    )
                  }
                </div>
              </section>


                {
                  bannerDetails.length > 0 && (
                    <div className='section2'>
                      <div className='row'>
                        {
                          bannerDetails.map((i, index) => (
                            <div key={index} className='col-md-6 col-sm-12'>
                              <Link to={i.url}>
                                <img
                                  alt='image'
                                  src={i.image}
                                  loading='lazy'
                                  className='flexImage'
                                  id={`flexImage${index + 1}`}
                                />
                              </Link>
                            </div>
                          ))
                        }
                      </div>
                    </div>
                  )
                }
              </div>
              <Marquee
                pauseOnHover={true}
                className='marqueeText'
                style={{ backgroundColor: primaryColor }}
              >
                {
                  announcementList.map(i => (
                    <Link key={i.id} to={i.url} className='marqueeLink' target='_blank'>
                      {`| ${i.name} |`}
                    </Link>
                  ))
                }
              </Marquee>
              <div className='container standartListStyle seoText'>
                <h2>GRC.UA - сайт з пошуку роботи для професіоналів в Україні</h2>
                <p>
                  GRC.UA – провідний <strong>сайт з пошуку роботи</strong>, що спеціалізується на вакансіях для професіоналів та
                  керівників в Україні. Наша платформа об&apos;єднує найкращі пропозиції на ринку праці та спрямована на те, щоб зробити
                  <strong> пошук роботи</strong> максимально зручним та ефективним для спеціалістів різних галузей та регіонів України.
                </p>
                <p>
                  Сьогодні ринок праці зазнав суттєвих знім і роботодавці у фокусі своєї діяльності з управління людським капіталом ставлять
                  в пріоритет низку важливих HR-задач.
                </p>
                <div style={{ display: showSeoText ? 'block' : 'none' }}>
                  <p>
                    За результатами нашого опитування Барометр ринку праці, ТОП-5 задач, що є у фокусі бізнесу, виглядають наступним чином:
                  </p>
                  <ol>
                    <li><strong>Навчання та розвиток персоналу</strong> – 59%</li>
                    <li><strong>Управління продуктивністю працівників</strong> – 49%</li>
                    <li><strong>Підбір персоналу</strong> – 44%</li>
                    <li><strong>Підвищення залученості працівників</strong> – 43%</li>
                    <li><strong>Підтримка ментального здоров&apos;я та wellbeing програми</strong> – 33%</li>
                  </ol>
                  <p>
                    Крім того, кожна п&apos;ята компанія зазначила, що трансформація корпоративної культури є пріоритетом бізнесу. Інші важливі
                    аспекти, на які звертають увагу роботодавці, включають:
                  </p>
                  <ul>
                    <li>Покращення досвіду взаємодії працівників з компанією – 16%</li>
                    <li>Адаптація колективу до повернення ветеранів та їх інтеграція у професійне життя – 14%</li>
                    <li>Матеріальна підтримка постраждалих під час війни – 8%</li>
                  </ul>
                  <p>
                    Наш <strong>сайт для пошуку роботи</strong> допомагає компаніям та спеціалістам знайти один одного, враховуючи сучасні виклики.
                    Ми співпрацюємо з провідними роботодавцями, які мають відкриті вакансії для <strong>керівників</strong> та
                    <strong> професіоналів</strong> у різних сферах.
                  </p>
                  <p>
                    Завдяки широкому вибору вакансій та можливостям для кар&apos;єрного розвитку, ми пропонуємо рішення для тих, хто прагне знайти
                    <strong> роботу в Україні</strong> у провідних компаніях, що працюють над розвитком своїх команд та корпоративної культури.
                    <strong> Сайти з пошуку роботи</strong> – це найефективніший інструмент для професіоналів, що хочуть бути в курсі нових можливостей
                    на ринку праці. Згідно зі щорічним опитуванням Барометр ринку праці від GRC.UA наразі 71% шукачів використовують сайти пошуку роботи
                    як основний канал отримання інформації про майбутнього роботодавця та його наявні вакансії в Україні.
                  </p>
                  <p>
                    Приєднуйтеся до нашого <strong>сайту з пошуку роботи</strong> вже сьогодні та знайдіть роботу, що відповідає вашим професійним амбіціям!
                  </p>
                </div>
                <button onClick={() => toggleSeoText()}>
                  {
                    showSeoText
                      ? 'приховати ...'
                      : 'показати більше ...'
                  }
                </button>
              </div>
              <Footer />
            </div>
          )
      }
    </>
  );
};


// document.addEventListener('mousemove', parallax);

// function parallax(e) {
//   this.querySelectorAll('.layer').forEach(layer => {
//     const speed = layer.getAttribute('data-speed');
//     const x = (window.innerWidth - e.pageX * speed) / 900;
//     const y = (window.innerWidth - e.pageY * speed) / 900;
//     layer.style.transform = `translate(${x}px, ${y}px)`;
//   });
// }
